import { post } from "../GenericServices";

const Authentication = {
  login: (data) => {
    return post("auth", data);
  },
  recoveryPassword: (data) => {
    return post("auth/reset-password", data);
  },
  resetPassword: (data) => {
    return post("auth/change-password", data);
  },
  changeUser: (username) => {
    return post(`auth/change-user/${username}`, {});
  },
};

export default Authentication;
